// ═══════════════════════════════════════════════════════════════════════════
// Catálogo FIXO de códigos de erro (de-para) — Frente 10
// A tabela de referência humana fica em docs/CODIGOS_DE_ERRO.md e DEVE ser
// mantida em sincronia com este arquivo. Os códigos são estáveis: ao contatar
// o suporte informando o código, sabemos o tipo de falha ocorrida.
// ═══════════════════════════════════════════════════════════════════════════

export interface ClassifiedError {
  code: string;
  message: string;
}

// Mensagem única exibida ao usuário (o código muda conforme o tipo).
const FRIENDLY = 'Desculpe, tivemos um erro. Tente novamente.';

export const ERROR_CATALOG: Record<string, string> = {
  'GEN-000': 'Erro inesperado não classificado.',
  'AUTH-001': 'Sessão expirada ou usuário não autenticado.',
  'PERM-002': 'Acesso negado / violação de isolamento multi-tenant (RLS).',
  'EF-003': 'Falha em função de servidor (Edge Function retornou erro).',
  'NET-004': 'Falha de conexão de rede com o servidor.',
  'DB-005': 'Erro de banco de dados (constraint, integridade ou conflito).',
  'VAL-006': 'Dados inválidos enviados pelo formulário.',
  'RATE-007': 'Muitas tentativas em pouco tempo (rate limit).',
  'STORAGE-008': 'Falha ao enviar ou ler arquivo no armazenamento.',
};

/** Classifica um erro qualquer em um código fixo do catálogo. */
export function classifyError(err: unknown): ClassifiedError {
  const raw =
    err instanceof Error ? err.message
    : typeof err === 'string' ? err
    : (() => { try { return JSON.stringify(err); } catch { return String(err); } })();
  const m = (raw || '').toLowerCase();

  let code = 'GEN-000';
  if (/row-level security|violates row-level|permission denied|not authorized|rls|policy/.test(m)) code = 'PERM-002';
  else if (/non-2xx|edge function|functionshttperror|functionsrelayerror/.test(m)) code = 'EF-003';
  else if (/failed to fetch|networkerror|network request failed|load failed|err_network/.test(m)) code = 'NET-004';
  else if (/rate limit|too many requests|429|for security purposes/.test(m)) code = 'RATE-007';
  else if (/storage|bucket|object not found|upload/.test(m)) code = 'STORAGE-008';
  else if (/jwt|not authenticated|unauthorized|401|session|invalid login/.test(m)) code = 'AUTH-001';
  else if (/duplicate key|violates|constraint|foreign key|integrity|conflict|deadlock|database/.test(m)) code = 'DB-005';
  else if (/invalid|required|inválid|obrigatóri|validation|malformed/.test(m)) code = 'VAL-006';

  return { code, message: `${FRIENDLY} (código ${code})` };
}

/** Mensagem amigável pronta para exibir, com o código embutido. */
export function friendlyError(err: unknown): string {
  return classifyError(err).message;
}
